"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSetNotification;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSetNotification() {
  return (0, _useWebChatAPIContext.default)().setNotification;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTZXROb3RpZmljYXRpb24iLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsInNldE5vdGlmaWNhdGlvbiJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVNldE5vdGlmaWNhdGlvbi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgTm90aWZpY2F0aW9uIGZyb20gJy4uL3R5cGVzL05vdGlmaWNhdGlvbic7XG5pbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNldE5vdGlmaWNhdGlvbigpOiAobm90aWZpY2F0aW9uOiBOb3RpZmljYXRpb24pID0+IHZvaWQge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5zZXROb3RpZmljYXRpb247XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUVlLFNBQVNBLGtCQUFULEdBQW9FO0VBQ2pGLE9BQU8sSUFBQUMsNkJBQUEsSUFBdUJDLGVBQTlCO0FBQ0QifQ==